import { render } from "./ZenTwo.vue?vue&type=template&id=50ddbe8f"
import script from "./ZenTwo.vue?vue&type=script&lang=js"
export * from "./ZenTwo.vue?vue&type=script&lang=js"

import "./ZenTwo.vue?vue&type=style&index=0&id=50ddbe8f&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__